import BracketGameMetaParticipantsModel from "./BracketGameMetaParticipantsModel";

export default class BracketGameMetaModel {
  public participants: BracketGameMetaParticipantsModel[] = [];
}
